import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import { RECOMMEND_TAG_PAGE_NAME } from '../../../constants/service/app/recommendTagConstants';
import RecommendTagDetailContainer from '../../../containers/recommend/tag/RecommendTagDetailContainer';

const RecommendTagDetail = () => {
  return (
    <PageTemplate pageName={RECOMMEND_TAG_PAGE_NAME.RECOMMEND_TAG_DETAIL}>
      <RecommendTagDetailContainer />
    </PageTemplate>
  );
};

export default RecommendTagDetail;
